import * as React from "react";
import PropTypes from "prop-types";

const StyledTable = ({ headers, rows, style = {}, dense = false }) => {
  const padding = dense ? "4px 8px" : "8px 16px";
  const fontSize = dense ? "12px" : "14px";

  return (
    <table
      style={{
        width: "100%",
        borderCollapse: "collapse",
        border: "none",
        fontSize,
        textAlign: "left",
        ...style,
      }}
    >
      <thead>
        <tr style={{ backgroundColor: "#333", color: "white" }}>
          {headers.map((header, index) => (
            <th key={index} style={{ padding, border: "none" }}>
              {header}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((row, rowIndex) => (
          <tr
            key={rowIndex}
            style={{
              backgroundColor: rowIndex % 2 === 0 ? "#f9f9f9" : "#eee",
              border: "none",
            }}
          >
            {Object.values(row).map((cell, cellIndex) => (
              <td key={cellIndex} style={{ padding, border: "none" }}>
                {cell}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

StyledTable.propTypes = {
  headers: PropTypes.arrayOf(PropTypes.node).isRequired,
  rows: PropTypes.arrayOf(PropTypes.object).isRequired,
  style: PropTypes.object,
  dense: PropTypes.bool,
};

export default StyledTable;
